type ProcessImageType = {
  blob: Blob;
  resolution: { width: number; height: number };
};

export const renderImageFileToJpegBlob = (
  file: Blob,
  maxWidth?: number,
  maxHeight?: number,
): Promise<ProcessImageType> => {
  const img = new Image();
  const objectUrl = URL.createObjectURL(file);
  const promise = new Promise<ProcessImageType>((resolve, reject) => {
    img.onerror = () => reject();
    img.onload = (event) => {
      const element = event.target;
      if (!(element instanceof HTMLImageElement)) {
        reject();
        return;
      }
      const canvas = document.createElement('canvas');
      const clampedWidth =
        maxWidth && element.width > maxWidth ? maxWidth : element.width;
      const clampedHeight =
        maxHeight && element.height > maxHeight ? maxHeight : element.height;
      let ratio = 0;
      const width = element.width;
      const height = element.height;

      if (width >= height) {
        ratio = clampedWidth / width;
        canvas.width = clampedWidth;
        canvas.height = height * ratio;
      }
      if (height > width) {
        ratio = clampedHeight / height;
        canvas.height = clampedHeight;
        canvas.width = width * ratio;
      }
      document.body.appendChild(canvas);
      canvas.style.position = 'fixed';
      canvas.style.top = '10000';
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject();
        return;
      }
      ctx.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        canvas.width,
        canvas.height,
      );

      canvas.toBlob((blob) => {
        if (blob) {
          document.body.removeChild(canvas);
          resolve({
            blob,
            resolution: { width: canvas.width, height: canvas.height },
          });
          return;
        }
        document.body.removeChild(canvas);
        reject();
      }, 'image/jpeg');
    };
  }).finally(() => {
    URL.revokeObjectURL(objectUrl);
  });
  img.src = objectUrl;
  return promise;
};
